var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "article-card-wrapper"
  }, [_vm._l(5, function (item) {
    return _c("a-skeleton", {
      key: item,
      attrs: {
        avatar: "",
        active: "",
        paragraph: {
          rows: 4
        },
        loading: _vm.loading
      }
    });
  }), _vm._l(_vm.articleList, function (item) {
    return _c("section", {
      key: item.id,
      staticClass: "article-card clearfix"
    }, [_c("section", {
      staticClass: "article-card__left"
    }, [_c("img", {
      attrs: {
        src: item.image,
        alt: ""
      }
    })]), _c("section", {
      staticClass: "article-card__right"
    }, [_c("a", {
      attrs: {
        href: item.url,
        target: "_blank",
        title: item.title
      }
    }, [_c("h4", {
      staticClass: "puhui-M"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])]), _c("a", {
      attrs: {
        href: item.url,
        target: "_blank",
        title: item.news_abstract
      }
    }, [_c("p", [_vm._v(" " + _vm._s(item.news_abstract.replace(/\s/g, "")) + " ")])]), _c("section", {
      staticClass: "card-bottom"
    }, [_c("img", {
      staticClass: "avatar",
      attrs: {
        src: require("@/assets/images/news/maleHead.png"),
        alt: ""
      }
    }), _c("span", {
      staticClass: "author"
    }, [_vm._v(_vm._s(item.publisher))]), _c("a-divider", {
      attrs: {
        type: "vertical"
      }
    }), _c("span", {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("dateFormatter")(item.create_time)))])], 1)])]);
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };